import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

const AK = "gm_access";
const RK = "gm_refresh";
export const tokens = {
  set(a, r) { localStorage.setItem(AK, a); if (r) localStorage.setItem(RK, r); },
  clear() { localStorage.removeItem(AK); localStorage.removeItem(RK); },
  access: () => localStorage.getItem(AK),
};

api.interceptors.request.use((c) => {
  const t = tokens.access();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

let refreshing = null;
api.interceptors.response.use((r) => r, async (err) => {
  const cfg = err.config || {};
  const rt = localStorage.getItem(RK);
  if (err.response?.status === 401 && !cfg._retry && rt && !/auth\/(login|register|refresh)/.test(cfg.url || "")) {
    cfg._retry = true;
    try {
      refreshing = refreshing || axios.post(`${BACKEND}/api/auth/refresh`, { refresh_token: rt }, { withCredentials: true });
      const { data } = await refreshing;
      tokens.set(data.access_token, data.refresh_token);
      cfg.headers.Authorization = `Bearer ${data.access_token}`;
      return api(cfg);
    } catch (e) {
      tokens.clear();
    } finally {
      refreshing = null;
    }
  }
  return Promise.reject(err);
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg.replace("Value error, ", "") : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const naira = (n) => `₦${Number(n || 0).toLocaleString("en-NG", { maximumFractionDigits: 2 })}`;
export const media = (u) => (u && u.startsWith("/api") ? `${BACKEND}${u}` : u);
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

export async function downloadTemplate(templateId) {
  const { data } = await api.post(`/downloads/${templateId}/link`);
  const a = document.createElement("a");
  a.href = `${BACKEND}${data.url}`;
  a.download = data.filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  return data.filename;
}

export const FORMATS = ["CDR", "PSD", "AI", "PDF", "EPS", "SVG", "JPG", "PNG", "CANVA"];
export const SOFTWARE = ["CorelDRAW", "Photoshop", "Illustrator", "Canva", "InDesign", "Figma", "Affinity Designer"];
